import { EnsuranceOffer } from '@/actions/types/EnsuranceOffer';
import { GetIsDevMode } from '../shared/IsDevMode';

export const isVisibleFailedEnsurance = (ensurance: EnsuranceOffer) => {
  return (
    ensurance.failed &&
    ((ensurance.type !== 'Leistungsausschluss' && ensurance.type !== 'Ausgeblendet') || GetIsDevMode())
  );
};
